import jwtInterceoptor from "../components/shared/jwtInterceptor";
import {baseURL} from "../services/api";
import moment from "moment";
import {getEcFinV2} from "./EcritureComptableHeper";

/**
 *
 * @param invoices
 * @param account
 * @param pieces
 * @param dateFrom
 * @param dateTo
 * @param filterByDate
 * @return {*[]}
 */
export const getTotalOfAccount = (invoices, account, pieces = [],dateFrom=null,dateTo=null,filterByDate=false) => {
    let res = [];
    let condition=true;

    invoices.forEach((invoice) => {
        let dateCreatedAt = new Date(invoice.created_at);
        if (!filterByDate) {
            condition = true;
        } else {
            condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
        }

        // Vérifiez que invoice et invoice.client et invoice.client.account ne sont pas null
        if (invoice?.client?.account?.code?.slice(0, 4) === account.slice(0, 4) && condition) {
            console.log("res: ", res, "invoice.client.account.code! ", invoice.client.account.code);

            let index_already_exist_element = alreadYExist(res, invoice.client.account.code);

            if (index_already_exist_element >= 0) {
                console.log("already exist");
                res[index_already_exist_element]['totaldebit'] = invoice.type === 'vente' ? parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(invoice.total_ttc) :
                    invoice.type === 'avoir' ? parseFloat(res[index_already_exist_element]['totaldebit']) - parseFloat(invoice.total_ttc) : parseFloat(0);
                res[index_already_exist_element]['totalcredit'] = invoice.type !== 'vente' && invoice.type !== 'avoir' ? parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(invoice.total_ttc) : parseFloat(0);
            } else {
                console.log("does not exist is new ", index_already_exist_element);
                res.push({
                    'code': invoice.client.account.code,
                    'totaldebit': invoice.type === 'vente' ? parseFloat(invoice.total_ttc) :
                        invoice.type === 'avoir' ? parseFloat(invoice.total_ttc) * -1 : parseFloat(0),
                    'totalcredit': invoice.type !== 'vente' && invoice.type !== 'avoir' ? parseFloat(invoice.total_ttc) : parseFloat(0)
                });
            }
        }
    });

    if (pieces.length > 0) {
        pieces.forEach(piece => {
            let dateCreatedAt = new Date(piece.created_at);
            if (!filterByDate) {
                condition = true;
            } else {
                condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
            }

            // Vérifiez que piece et piece.debit_credit sont valides
            piece?.debit_credit?.forEach(dc => {
                // Vérifiez que dc et dc.account sont valides
                if (dc?.account?.code?.slice(0, 4) === account.slice(0, 4) && condition) {
                    console.log("true, code is : ", dc.account.code);

                    let index_already_exist_element = alreadYExist(res, dc.account.code);
                    if (index_already_exist_element >= 0) {
                        res[index_already_exist_element]['totaldebit'] = parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(piece.total_debit);
                        res[index_already_exist_element]['totalcredit'] = parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(piece.total_credit);
                    } else {
                        res.push({
                            'code': dc.account.code,
                            'totaldebit': piece.total_debit,
                            'totalcredit': piece.total_credit
                        });
                    }
                }
            });
        });
    }

    return res;
}

/**
 *
 * @param code
 * @return {boolean}
 */
const isBqSousCompte = (code) => {
    console.log("code : ",code);
    return code.substring(0, 4) === "5141";
};

/**
 *
 * @param code
 * @return {boolean}
 */
const isCsSousCompte = (code) => {
    return code.substring(0, 4) === "5161";
};

/**
 *
 * @param invoices
 * @param account
 * @param pieces
 * @param dateFrom
 * @param dateTo
 * @param filterByDate
 * @return {*[]}
 */
export const getBqAccountTotal =  (invoices, account, pieces = [],dateFrom=null,dateTo=null,filterByDate=false) => {
    let res=[];
    for (let i = 0; i < invoices.length; i++) {
        let flux = getEcFinV2(invoices[i],dateFrom,dateTo,filterByDate);
        flux.map((f) => {
            if (account === "51410000" && isBqSousCompte(f.payment_account)) {
                let index_already_exist_element = alreadYExist(res, f.payment_account);
                if (index_already_exist_element >= 0) {
                    res[index_already_exist_element]['totaldebit'] = invoices[i].type === 'vente' ? parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(f.total_ttc) : parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(0);
                    res[index_already_exist_element]['totalcredit'] = invoices[i].type === 'vente' ? parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(0) : parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(f.total_ttc);
                } else {
                    res[res.length] = {
                        'code': f.payment_account,
                        'totaldebit': invoices[i].type === 'vente' ? parseFloat(f.total_ttc) : 0,
                        'totalcredit': invoices[i].type === 'vente' ? 0 : parseFloat(f.total_ttc)
                    };
                }
            } else if (account === "51610000" && isCsSousCompte(f.payment_account)) {
                let index_already_exist_element = alreadYExist(res, f.payment_account);
                if (index_already_exist_element >= 0) {
                    res[index_already_exist_element]['totaldebit'] = invoices[i].type === 'vente' ? parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(f.total_ttc) : parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(0);
                    res[index_already_exist_element]['totalcredit'] = invoices[i].type === 'vente' ? parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(0) : parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(f.total_ttc);
                } else {
                    res[res.length] = {
                        'code': f.payment_account,
                        'totaldebit': invoices[i].type === 'vente' ? parseFloat(f.total_ttc) : 0,
                        'totalcredit': invoices[i].type === 'vente' ? 0 : parseFloat(f.total_ttc)
                    };
                }
            }
        });
    }

    let condition=true;

    if (pieces.length > 0) {
        for (let i = 0; i < pieces.length; i++) {
            let dateCreatedAt = new Date(pieces[i]['created_at']);
            if (!filterByDate) {
                condition = true;
            } else {
                condition = dateCreatedAt >= dateFrom && dateCreatedAt <= dateTo;
            }

            console.log("inside for loop, pieces :  ", pieces)
            for (let j = 0; j < pieces[i]['debit_credit'].length; j++) {
                if (pieces[i]['debit_credit'][j]['account']['code'].slice(0, 4) === account.slice(0, 4) && condition) {
                    console.log("true, code is : ", pieces[i]['debit_credit'][j]['account']['code'])
                    console.log("****************")
                    console.log(pieces[i])
                    console.log("****************")
                    let index_already_exist_element = alreadYExist(res, pieces[i]['debit_credit'][j]['account']['code']);
                    if (index_already_exist_element >= 0) {
                        res[index_already_exist_element]['totaldebit'] = parseFloat(res[index_already_exist_element]['totaldebit']) + parseFloat(pieces[i]['debit_credit'][j]['debit']);
                        res[index_already_exist_element]['totalcredit'] = parseFloat(res[index_already_exist_element]['totalcredit']) + parseFloat(pieces[i]['debit_credit'][j]['credit']);
                    } else {
                        res[res.length] = {
                            'code': pieces[i]['debit_credit'][j]['account']['code'],
                            'totaldebit': pieces[i]['debit_credit'][j]['debit'],
                            'totalcredit': pieces[i]['debit_credit'][j]['credit']
                        };
                    }
                }
            }
        }
    }

    //205 + 202

    return res;
}


const alreadYExist = (r, code) => {
    for (let i = 0; i < r.length; i++) {
        console.log("i :", i, " , res['code']: ", r[i]['code'], 'code: ', code)
        if (r[i]['code'] === code) {
            return i;
        }
    }
    return -1;
}